import { OUTPUT_TTL } from '../../../constants/Pac';
import type RootStore from '../../root-store';

/**
 * Vibrator controller
 *
 * @param rootStore
 * @param vibratorId
 * @param turnOn
 */
export const vibratorSwitch = (
  rootStore: RootStore,
  vibratorId: number,
  turnOn: boolean = true,
) => {

  const { batchStore, devicesStore } = rootStore;

  if (vibratorId) {
    const vibrator = devicesStore.getDeviceById(vibratorId);

    if (vibrator?.switchOnePNo) {

      if (batchStore.isOutputOn(vibrator.switchOnePNo) === turnOn) {
        return;
      }

      batchStore.setOutput(vibrator.switchOnePNo, turnOn ? OUTPUT_TTL : '0');
    }
  }
};
